import React, { Component } from 'react';
import { EventEmitter } from 'events';
import ReactModal from 'react-modal';

import AddBlockTimeForm from './addBlockTimeContainer';
import EditBlockTimeForm from './editBlockTimeContainer';

export default class BlockTimeModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      barber: {},
      opened: false,
      dayOff: null,
    };
  }

  componentDidMount() {
    EventEmitter.prototype.on('open-block-time-modal', this.openModal);
    EventEmitter.prototype.on('modal-closed', this.closeModal);
  }

  componentWillUnmount() {
    EventEmitter.prototype.removeListener('open-block-time-modal', this.openModal);
    EventEmitter.prototype.removeListener('modal-closed', this.closeModal);
  }

  updateProps = (data) => {
    this.setState({ data });
  }

  openModal = (options) => {
    this.setState({
      opened: true,
      ...options,
    });
  }

  closeModal = () => {
    if (this.state.opened) {
      this.setState({
        opened: false,
        barber: {},
        start: null,
        end: null,
        dayOff: null,
      });
    }
  }

  render() {
    const BlockTimeForm = this.state.dayOff ? EditBlockTimeForm : AddBlockTimeForm;
    return (
      <ReactModal
        className={{
          base: 'remodal remodal-is-initialized remodal-is-opening u-animation-fill-mode-none u-width-710',
          afterOpen: 'remodal-is-opened',
          beforeClose: 'remodal-is-closing',
        }}
        overlayClassName={{
          base: 'remodal-overlay remodal-wrapper remodal-is-initialized remodal-is-opening u-animation-fill-mode-none',
          afterOpen: 'remodal-is-opened',
          beforeClose: 'remodal-is-closing',
        }}
        closeTimeoutMS={150}
        onRequestClose={this.closeModal}
        contentLabel="Modal"
        shouldCloseOnOverlayClick
        isOpen={this.state.opened}
        ariaHideApp={false}
      >
        <BlockTimeForm
          afterSave={this.closeModal}
          afterDelete={this.closeModal}
          barberId={this.state.barberId || null}
          start={this.state.start}
          end={this.state.end}
          dayOff={this.state.dayOff}
          hideBarber={this.state.hideBarber}
        />
      </ReactModal>
    );
  }
}
